export const mixSection = 'html-email-body-section-mix';
export const mixSectionNoWrap = 'html-email-body-section-mix-no-wrap';
export const mixColumnNoWrap = 'html-email-mix-column-no-wrap';
export const mixColumn = 'html-email-mix-column';
export const mixLeftColumn = 'html-email-mix-left-column';
export const mixRightColumn = 'html-email-mix-right-column';
export const mixButton = 'html-emails-mix-button';
export const mixText = 'html-emails-mix-text';
export const mixImageWrapper = 'html-emails-mix-image-wrapper';
export const mixImageWrapperFullWidth = 'html-emails-mix-image-wrapper-full-width';
export const mixImageWithPadding = 'html-emails-mix-image-with-paddings';
export const mixSpacer = 'html-emails-region-mix-spacer';
//# sourceMappingURL=mix-css-classes.js.map